<template>
    <div class="form-row step-row justify-content-center">
        <div class="col-auto p-0">
            <div class="step-items-wrapper scrollable-list form-row justify-content-center">
                <template v-for="item in items">
                    <div class="step-item col-12" v-bind:key="item.value">
                        <button class="btn step-btn form-control" v-on:click="onclick(item.value)">{{ item.text }}</button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ScrollableButtonList",
        props: {
            items: Array,
            onclick: Function
        }
    }
</script>

<style scoped>

.scrollable-list {
    width: 100%;
    overflow-y: auto;
    margin: 0 !important;
    padding-left: 5px;
    padding-right: 5px;
}

.scrollable-list .step-item .btn {
    background-color: transparent !important;
    color: white;
    white-space: normal;
    word-wrap: break-word;
    height: 100%;
}

.scrollable-list .step-item .btn:focus {
    box-shadow: none;
    border-color: transparent;
    text-decoration: underline;
}

</style>
